import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ILimitHistory } from '../models/models'

export class LimitHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productLimit/listHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<ILimitHistory[]> {
    return await this.postAsync<ILimitHistory[]>(request)
  }
}
